import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=d85761ec&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d85761ec')) {
      api.createRecord('d85761ec', component.options)
    } else {
      api.reload('d85761ec', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=d85761ec&", function () {
      api.rerender('d85761ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2SlpSuFoPezTE/JS/comp/IncreaseNumber.vue"
export default component.exports